import {
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfWeek,
  endOfWeek,
  subWeeks,
  subYears,
  startOfYear,
  endOfYear,
  subDays,
  addMonths,
  addDays,
  addWeeks,
} from 'date-fns';
import { DayPreset, RangePreset } from '../../types/types';

export const getRangeForTimespan = (timeSpan) => {
  const curDate = new Date();
  switch (timeSpan) {
    case RangePreset.CURRENT_MONTH: {
      return {
        from: startOfMonth(curDate),
        to: endOfMonth(curDate),
      };
    }

    case RangePreset.CURRENT_WEEK: {
      return {
        from: startOfWeek(curDate, { weekStartsOn: 1 }),
        to: endOfWeek(curDate, { weekStartsOn: 1 }),
      };
    }

    case RangePreset.PREVIOUS_WEEK: {
      const prevWeekDate = subWeeks(curDate, 1);
      return {
        from: startOfWeek(prevWeekDate, { weekStartsOn: 1 }),
        to: endOfWeek(prevWeekDate, { weekStartsOn: 1 }),
      };
    }

    case RangePreset.NEXT_WEEK: {
      const nextWeekDate = addWeeks(curDate, 1);
      return {
        from: startOfWeek(nextWeekDate, { weekStartsOn: 1 }),
        to: endOfWeek(nextWeekDate, { weekStartsOn: 1 }),
      };
    }

    case RangePreset.PREVIOUS_MONTH: {
      const prevMonthDate = subMonths(curDate, 1);
      return {
        from: startOfMonth(prevMonthDate),
        to: endOfMonth(prevMonthDate),
      };
    }

    case RangePreset.CURRENT_YEAR: {
      return {
        from: startOfYear(curDate),
        to: endOfYear(curDate),
      };
    }

    case RangePreset.PREVIOUS_YEAR: {
      const prevYearDate = subYears(curDate, 1);
      return {
        from: startOfYear(prevYearDate),
        to: endOfYear(prevYearDate),
      };
    }

    case RangePreset.LAST_7_DAYS: {
      const from = subDays(curDate, 6);
      return {
        from: startOfDay(from),
        to: endOfDay(curDate),
      };
    }

    case RangePreset.LAST_2_MONTHS: {
      const from = subMonths(curDate, 1);
      return {
        from: startOfMonth(from),
        to: endOfMonth(curDate),
      };
    }

    case RangePreset.LAST_31_DAYS: {
      const from = subDays(curDate, 30);
      return {
        from: startOfDay(from),
        to: endOfDay(curDate),
      };
    }

    case RangePreset.TO_NEXT_MONTH_END: {
      const to = addMonths(curDate, 1);
      return {
        from: startOfDay(curDate),
        to: endOfMonth(to),
      };
    }

    case RangePreset.TO_YEAR_END: {
      return {
        from: startOfDay(curDate),
        to: endOfYear(curDate),
      };
    }

    case RangePreset.RECENT_21_DAYS: {
      const from = subWeeks(curDate, 1);
      const to = addDays(curDate, 13);
      return {
        from: startOfDay(from),
        to: endOfDay(to),
      };
    }

    case RangePreset.NEXT_14_DAYS: {
      const to = addDays(curDate, 13);
      return {
        from: startOfDay(curDate),
        to: endOfDay(to),
      };
    }

    case DayPreset.CURRENT_DAY:
    case DayPreset.TODAY: {
      return {
        from: startOfDay(curDate),
        to: endOfDay(curDate),
      };
    }

    case DayPreset.PREVIOUS_DAY: {
      const prevDayDate = subDays(curDate, 1);
      return {
        from: startOfDay(prevDayDate),
        to: endOfDay(prevDayDate),
      };
    }

    case DayPreset.TOMORROW: {
      const tomorrow = addDays(curDate, 1);
      return {
        from: startOfDay(tomorrow),
        to: endOfDay(tomorrow),
      };
    }

    default: {
      return {
        from: null,
        to: null,
      };
    }
  }
};
